import React from "react";
import type { TopCoupon } from "../types/merchant-home-data.types";
import { MerchantHomeErrorState } from "./MerchantHomeErrorState";
import { TopCoupons } from "./TopCoupons";

interface MerchantHomeTopCouponsSectionProps {
  coupons: TopCoupon[];
  hasData: boolean;
  loading: boolean;
  error: string | null;
  onRetry: () => void;
  onViewAll: () => void;
}

export const MerchantHomeTopCouponsSection: React.FC<MerchantHomeTopCouponsSectionProps> = ({
  coupons,
  hasData,
  loading,
  error,
  onRetry,
  onViewAll,
}) => {
  if (loading && !hasData) {
    return (
      <div className="min-h-[240px] flex-1 animate-pulse self-stretch rounded-2xl bg-white outline outline-1 outline-offset-[-1px] outline-gray-200 dark:bg-gray-800 dark:outline-gray-700" />
    );
  }

  if (error && !hasData) {
    return (
      <MerchantHomeErrorState
        message={error}
        onRetry={onRetry}
        className="flex-1 self-stretch"
      />
    );
  }

  return (
    <div className="flex flex-1 flex-col gap-4 self-stretch">
      {error ? (
        <div className="flex items-center justify-between gap-3 rounded-lg border border-red-200 bg-red-50 px-4 py-2 text-sm text-red-700 dark:border-red-700 dark:bg-red-900/20 dark:text-red-300">
          <span>{error}</span>
          <button
            type="button"
            onClick={onRetry}
            className="font-semibold hover:opacity-80"
          >
            Retry
          </button>
        </div>
      ) : null}
      <TopCoupons
        coupons={coupons}
        onViewAll={onViewAll}
      />
    </div>
  );
};
